/**
 * Left-and-right content section:
 * Override default autoplay.
 */

const SECTION_SELECTOR = '.e-stn--left-and-right-content';
const VIDEO_SELECTOR = '.e-vid video, .e-vid--video video';
const VISIBLE_RATIO_PLAY = 0.5;

function initLeftRightContentVideos() {
  const section = document.querySelector( SECTION_SELECTOR );
  if ( ! section ) return;

  const videos = section.querySelectorAll( VIDEO_SELECTOR );
  if ( ! videos.length ) return;

  // Override HTML autoplay
  videos.forEach( ( video ) => {
    if ( video instanceof HTMLVideoElement ) {
      video.pause();
      video.removeAttribute( 'autoplay' );
    }
  } );

  const observer = new IntersectionObserver(
    ( entries ) => {
      entries.forEach( ( entry ) => {
        const video = entry.target;
        if ( ! ( video instanceof HTMLVideoElement ) ) return;

        if ( entry.intersectionRatio > VISIBLE_RATIO_PLAY ) {
          video.play().catch( () => {} );
        } else {
          video.pause();
        }
      } );
    },
    {
      root: null,
      rootMargin: '0px',
      threshold: [ 0, 0.25, 0.5, 0.75, 1 ],
    }
  );

  videos.forEach( ( video ) => observer.observe( video ) );
}

document.addEventListener( 'DOMContentLoaded', initLeftRightContentVideos );
